import { createAction, props } from '@ngrx/store';

export const selectAllCustomersForUpdate = createAction(
  '[Customers] Select All Customers For Update',
  props<{ checked: boolean; allCustomers: boolean }>(),
);
